module.exports = __webpack_public_path__ + "img/watch.d86bda9c.svg";